import _ from 'lodash';

import { formatDuration } from './VendorRequestDetailDrawer/VendorRequestDetailDrawer.utils';

export const getGroupLatestActivity = group => _.get(group, 'latestActivityAt', null);

export const getGroupInitiatedByUserId = group => _.get(group, 'initiatedByUserId', null);

// Order-to-report span of the whole correlation: earliest RequestedAt to the latest terminal time.
// The async completion row carries RequestedAt == CompletedAt, so a per-item duration is always 0 —
// the real wait only exists across the group (LoanRequestGroupModel folds the min/max for us).
export const getGroupDuration = group =>
  formatDuration(
    _.get(group, 'requestedAt'),
    _.get(group, 'completedAt') ?? _.get(group, 'failedAt'),
  );
